import type { DataAttributeDto, FieldListDto } from './datamodel';
import { z } from 'zod';

const key = z.string().trim().min(1).max(160);
const fields = z
  .array(z.string().regex(/^[a-z][a-z0-9_]{0,62}$/))
  .max(300)
  .nullable();
export const DataGrantSchema = z.object({
  role_key: key,
  type_key: key,
  /** null = tutti i campi, scelto esplicitamente dal responsabile; [] = nessun campo. */
  read: fields.default([]),
  write: fields.default([]),
  approve: z.boolean().default(false),
  remove: z.boolean().default(false),
  company: z.boolean().default(false),
  documents: z.boolean().default(false),
});
export type DataGrant = z.infer<typeof DataGrantSchema>;
export const SaveDataGrantsSchema = z.object({ grants: z.array(DataGrantSchema).max(2000) });
export const PersonDataAccessSchema = z.object({ enabled: z.boolean() });
export const DataEntityWriteSchema = z.object({
  attributes: z.record(z.unknown()),
  expected_version: z.number().int().min(1).nullable(),
  site_id: z.string().uuid().nullable().optional(),
});
export const DataEntityDeleteSchema = z.object({ expected_version: z.number().int().min(1) });

/** Regola già risolta dal nucleo: campi e ambito restano accoppiati al medesimo ruolo. */
export const ArchiveAccessRuleSchema = z.object({
  type: key,
  role: key,
  read: fields,
  write: fields,
  approve: z.boolean(),
  remove: z.boolean(),
  company: z.boolean(),
  documents: z.boolean(),
  sites: z.array(z.string().uuid()).max(200).nullable(),
});
export type ArchiveAccessRule = z.infer<typeof ArchiveAccessRuleSchema>;
export const ArchiveAccessPolicySchema = z.object({
  subject: z.string().min(1).max(200),
  rules: z.array(ArchiveAccessRuleSchema).max(2000),
});
export type ArchiveAccessPolicy = z.infer<typeof ArchiveAccessPolicySchema>;

export interface DataAccessOptions {
  roles: Array<{ key: string; label: string }>;
  types: Array<{
    key: string;
    label: string;
    attributes: Array<{ name: string; label: string; reserved: boolean }>;
  }>;
  grants: DataGrant[];
  people: Array<{
    id: string;
    name: string;
    user_id: string | null;
    manager: boolean;
    access_scope: 'full' | 'tasks' | 'data' | null;
  }>;
}
export interface MyDataAccess {
  lists?: FieldListDto[];
  types: Array<{
    key: string;
    label: string;
    attributes: Array<
      { name: string; label: string; writable: boolean } & Partial<
        Pick<DataAttributeDto, 'tipo' | 'forma' | 'formato' | 'elenco' | 'unita' | 'multiplo'>
      >
    >;
    can_create: boolean;
    company: boolean;
    sites: Array<{ id: string; name: string }>;
  }>;
}
